// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.code-tips[data-v-163917e6] {\n\tpadding-left:0;\n}\n.code-tips[data-v-163917e6], .code-tips > li[data-v-163917e6] {\n\tlist-style: none;\n\tcolor: var(--main-gray-6);\n}\n.code-tips > li[data-v-163917e6]:before {\n\tcontent: \"* \";\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
